import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectContent } from "redux/features/dialog/dialogSlice"

export function withModalSubscriptionId<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithModalSubscriptionId = (props: GenericType) => {
    const content = useAppSelector((state) => selectContent(state))

    const { subscriptionId } = content
    return <WrappedComponent {...props} subscriptionId={subscriptionId} />
  }

  return WithModalSubscriptionId
}
